module.exports = __webpack_public_path__ + "static/excluding1-c3c7272dad39b1f4387e42acdbea8cdb.png";